import smoothscroll from 'smoothscroll-polyfill';

export const smoothScrollToTop = () => {
	smoothscroll.polyfill();
	window.scroll({top: 0, left: 0, behavior: 'smooth' })
};